// extracted by mini-css-extract-plugin
module.exports = {"component":"toast-notification-component--1Raqh"};